"use client"

import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from "recharts"

const chartData = [
  { month: "January", desktop: 186, mobile: 80 },
  { month: "February", desktop: 305, mobile: 200 },
  { month: "March", desktop: 237, mobile: 120 },
  { month: "April", desktop: 73, mobile: 190 },
  { month: "May", desktop: 209, mobile: 130 },
  { month: "June", desktop: 214, mobile: 140 },
]

export default function BarChartSample()  {
  return (
    <div style={{ minHeight: "200px", width: "100%", padding: "1rem" }}>
      <BarChart
        width={800}
        height={400}
        data={chartData}
        margin={{ top: 20, right: 30, left: 0, bottom: 5 }}
      >
        <CartesianGrid
          stroke="#e5e7eb"
          strokeDasharray="3 3"
          vertical={false}
        />
        <XAxis
          dataKey="month"
          stroke="#6b7280" // Color for the text
          fontSize={12}
          tickLine={false} // No tick marks (removes any "dots")
          axisLine={{ stroke: "#6b7280", strokeWidth: 1, strokeDasharray: "0" }} // Solid line
        />
        <YAxis
          stroke="#6b7280"
          fontSize={12}
          tickLine={false}
          axisLine={false}
          tickFormatter={(value) => `${value}`}
        />
        <Tooltip
          contentStyle={{
            backgroundColor: "#fff",
            border: "1px solid #e5e7eb",
            borderRadius: "4px",
            boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
          }}
          cursor={{ fill: "transparent" }} // No hover background
        />
        <Legend
          wrapperStyle={{
            paddingTop: "10px",
            fontSize: "14px",
            color: "#6b7280",
          }}
        />
        <Bar
          dataKey="desktop"
          fill="#2563eb"
          radius={[4, 4, 0, 0]}
          barSize={20}
          isAnimationActive={false}
        />
        <Bar
          dataKey="mobile"
          fill="#60a5fa"
          radius={[4, 4, 0, 0]}
          barSize={20}
          isAnimationActive={false}
        />
      </BarChart>
    </div>
  )
}